import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, articles } from '@/mocks/articles';
import Newsletter from '@/pages/home/components/Newsletter';

const articleImages: Record<string, string> = {
  'article-role-1': 'https://readdy.ai/api/search-image?query=Elegant%20woman%20gazing%20thoughtfully%20at%20her%20wedding%20ring%2C%20soft%20window%20light%2C%20cream%20blouse%2C%20warm%20minimalist%20interior&width=800&height=500&seq=cat-art-role-1&orientation=landscape',
  'article-role-2': 'https://readdy.ai/api/search-image?query=Mother%20in%20law%20and%20daughter%20in%20law%20sharing%20tea%20in%20a%20cozy%20living%20room%2C%20warm%20atmosphere%2C%20gentle%20smiles%2C%20cream%20interior&width=800&height=500&seq=cat-art-role-2&orientation=landscape',
  'article-role-3': 'https://readdy.ai/api/search-image?query=Professional%20woman%20working%20on%20laptop%20at%20a%20modern%20desk%2C%20home%20office%20setup%2C%20warm%20natural%20light%2C%20balanced%20lifestyle&width=800&height=500&seq=cat-art-role-3&orientation=landscape',
  'article-couple-1': 'https://readdy.ai/api/search-image?query=Couple%20having%20intimate%20conversation%20on%20balcony%20at%20sunset%2C%20warm%20golden%20light%2C%20holding%20hands%2C%20romantic%20atmosphere&width=800&height=500&seq=cat-art-couple-1&orientation=landscape',
  'article-couple-2': 'https://readdy.ai/api/search-image?query=Two%20people%20sitting%20close%20on%20a%20park%20bench%2C%20one%20giving%20a%20small%20gift%2C%20warm%20autumn%20colors%2C%20emotional%20connection&width=800&height=500&seq=cat-art-couple-2&orientation=landscape',
  'article-couple-3': 'https://readdy.ai/api/search-image?query=Couple%20reconciling%20after%20an%20argument%2C%20gentle%20embrace%2C%20soft%20lighting%2C%20cream%20and%20warm%20tones%2C%20emotional%20moment&width=800&height=500&seq=cat-art-couple-3&orientation=landscape',
  'article-marriage-1': 'https://readdy.ai/api/search-image?query=Two%20intertwined%20hands%20with%20wedding%20bands%2C%20soft%20silk%20background%2C%20delicate%20flowers%2C%20warm%20golden%20light&width=800&height=500&seq=cat-art-marr-1&orientation=landscape',
  'article-marriage-2': 'https://readdy.ai/api/search-image?query=Couple%20reviewing%20financial%20documents%20together%20at%20a%20cozy%20table%2C%20warm%20lighting%2C%20collaborative%20mood&width=800&height=500&seq=cat-art-marr-2&orientation=landscape',
  'article-marriage-3': 'https://readdy.ai/api/search-image?query=Couple%20dancing%20slowly%20in%20their%20living%20room%2C%20spontaneous%20romantic%20moment%2C%20warm%20candlelight%2C%20cream%20interior&width=800&height=500&seq=cat-art-marr-3&orientation=landscape',
  'article-newlywed-1': 'https://readdy.ai/api/search-image?query=Newlywed%20couple%20unpacking%20boxes%20in%20their%20first%20apartment%2C%20excited%20and%20playful%2C%20natural%20light&width=800&height=500&seq=cat-art-new-1&orientation=landscape',
  'article-newlywed-2': 'https://readdy.ai/api/search-image?query=Couple%20enjoying%20morning%20coffee%20together%20in%20a%20bright%20modern%20kitchen%2C%20casual%20and%20happy%2C%20lifestyle%20photography&width=800&height=500&seq=cat-art-new-2&orientation=landscape',
  'article-newlywed-3': 'https://readdy.ai/api/search-image?query=Woman%20practicing%20yoga%20in%20a%20sunlit%20room%2C%20peaceful%20expression%2C%20cream%20and%20sage%20tones%2C%20self%20care%20moment&width=800&height=500&seq=cat-art-new-3&orientation=landscape',
  'article-family-1': 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20warm%20blankets%20and%20candles%2C%20soft%20evening%20light%2C%20cream%20and%20taupe%20interior%2C%20inviting%20home&width=800&height=500&seq=cat-art-fam-1&orientation=landscape',
  'article-family-2': 'https://readdy.ai/api/search-image?query=Couple%20cooking%20dinner%20together%20in%20a%20warm%20kitchen%2C%20laughing%2C%20fresh%20ingredients%2C%20cozy%20evening%20atmosphere&width=800&height=500&seq=cat-art-fam-2&orientation=landscape',
  'article-self-1': 'https://readdy.ai/api/search-image?query=Confident%20woman%20journaling%20in%20a%20cozy%20cafe%2C%20warm%20ambient%20light%2C%20notebook%20and%20coffee%2C%20serene%20expression&width=800&height=500&seq=cat-art-self-1&orientation=landscape',
  'article-self-2': 'https://readdy.ai/api/search-image?query=Woman%20painting%20on%20canvas%20in%20a%20bright%20studio%2C%20passionate%20expression%2C%20creative%20atmosphere%2C%20warm%20natural%20light&width=800&height=500&seq=cat-art-self-2&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];
  const categoryArticles = articles.filter((a) => a.categorySlug === activeSlug);
  const otherCategories = categories.filter((c) => c.slug !== activeSlug);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://diyiciderenqi.com/' },
              { '@type': 'ListItem', position: 2, name: currentCategory.name, item: `https://diyiciderenqi.com/category/${activeSlug}` },
            ],
          }),
        }}
      />

      <main className="pt-16 bg-background-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <Breadcrumb
            items={[
              { label: '首页', to: '/' },
              { label: currentCategory.name },
            ]}
          />

          <div className="flex flex-col lg:flex-row gap-8 md:gap-10">
            <aside className="lg:w-64 flex-shrink-0">
              <div className="lg:sticky lg:top-24">
                <h2 className="text-lg font-heading font-semibold text-foreground-900 mb-4">内容分类</h2>
                <nav className="space-y-1">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all duration-200 ${
                        activeSlug === cat.slug
                          ? 'bg-primary-50 text-primary-600 font-medium'
                          : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                      }`}
                    >
                      <span className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                        <i className={`${cat.icon} text-sm ${activeSlug === cat.slug ? 'text-primary-500' : 'text-foreground-500'}`}></i>
                      </span>
                      <span className="whitespace-nowrap">{cat.name}</span>
                    </Link>
                  ))}
                </nav>
              </div>
            </aside>

            <div className="flex-1 min-w-0">
              <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-2">
                  {currentCategory.name}
                </h1>
                <p className="text-foreground-600 text-sm md:text-base">{currentCategory.description}</p>
              </div>

              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
                  {categoryArticles.map((article) => (
                    <article
                      key={article.id}
                      className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                    >
                      <Link to={`/article/${article.slug}`} className="block">
                        <div className="relative aspect-[16/9] overflow-hidden">
                          <img
                            src={articleImages[article.imageSeq]}
                            alt={article.title}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            loading="lazy"
                          />
                          <div className="absolute top-3 left-3">
                            <span className="px-2.5 py-1 text-xs rounded-full bg-white/85 backdrop-blur-sm text-foreground-700 font-medium">
                              {article.category}
                            </span>
                          </div>
                        </div>
                        <div className="p-4 md:p-5">
                          <h3 className="text-base md:text-lg font-heading font-medium text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                            {article.title}
                          </h3>
                          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                            {article.excerpt}
                          </p>
                          <div className="flex items-center gap-3 text-xs text-foreground-500">
                            <span className="flex items-center gap-1">
                              <i className="ri-calendar-line"></i> {article.date}
                            </span>
                            <span className="flex items-center gap-1">
                              <i className="ri-time-line"></i> {article.readTime}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </article>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <p className="text-foreground-500">暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {otherCategories.length > 0 && (
          <section className="mt-14 md:mt-20 py-14 md:py-20 bg-background-100" data-product-shop>
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-8 text-center">
                探索更多分类
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
                {otherCategories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center cursor-pointer group"
                  >
                    <span className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-secondary-100 flex items-center justify-center group-hover:bg-primary-50 transition-colors">
                      <i className={`${cat.icon} text-base md:text-lg text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
                    </span>
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}

        <Newsletter />
      </main>
    </>
  );
}